import React, { useEffect, useState } from 'react';
import { StatOptions } from 'fs';
import { NavLink, useNavigate } from 'react-router-dom';
import { LoginModel } from './models/LoginModel';
import { useDispatch, useSelector } from 'react-redux';
import { Notifications } from './components/_Notifications';
import { setBranchesData } from './app-context/policyProduction';
import { setLoadTreatmentToQueue } from './app-context/caller';
type Props = {
    PageName:string
  };
  
 
const Header = (props: Props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userLogged = useSelector((state: any) => state.user.value)
    const callStarted = useSelector((state: any) => state.call.value)
    const loginModel: LoginModel = new LoginModel();
    const [userData, setUserData] = useState<any>({})
    const [inBreak, setInBreak] = useState<boolean>(localStorage.getItem('break')=='true')

    const logOut = async(e: any) => {
      dispatch(setBranchesData({project:'', branch:'', user:''}));
      dispatch(setLoadTreatmentToQueue({ load: true })); // Reset the flag redux state after logut
      await loginModel.logOut(true);
      navigate('/Login');
      e.preventDefault()
    }

    const GoToBreak = async(e: any) => {
      await loginModel.Break();
      setInBreak(true);
      e.preventDefault()
    }

    const BreakEnd = async(e: any) => {
      await loginModel.BreakEnd();
      setInBreak(false);
      e.preventDefault()
    }
    useEffect(()=>{
      const parsedData = localStorage.getItem('loggedUser');
      if (parsedData) {
        const loggedUser = JSON.parse(parsedData)
        setUserData(loggedUser);
      }
    }, [])
    
    
      return (   
        <header className="header flex-centered flex-space-between">
                <div className="side-menu mobile-only">
                    <div className="icon menu"></div>
                </div>
                <div className="logo mobile-only" 
                // style={{marginRight: 70}}
                ></div>
                <div className="actions mobile-only flex-centered flex-space-between">
                    <div className="sign-out-link">
                      <a className="" href="#" onClick={(e:any)=>logOut(e)}>התנתק</a>&nbsp; 
                    </div>
                    <div className="icon user"></div>
                    <div className="icon notifications"></div>
                </div>
                <div className="content-main-title desktop-only">
                    {props.PageName}
                </div>
                <div className="side-options">
                    <div className="sign-out-link">
                    <a className="" href="#" onClick={(e:any)=>logOut(e)}>התנתק</a>&nbsp; 
                    
                      
                    </div>
                    <div className="divider">|</div>
                    <div className="sign-out-link">
                    {/* <div>{userLogged ? 'Logged In' : 'Logged Out'}</div> */}
                    {/* <div>{callStarted ? 'In Call' : 'Not In Call'}</div> */}
                    <a className={inBreak?"hide":""} href="#" onClick={(e:any)=>GoToBreak(e)}>צא להפסקה</a>
                      
                    </div>
                    <div className="sign-out-link">
                    <a className={inBreak?"":"hide"} href="#" onClick={(e:any)=>BreakEnd(e)}>חזור מהפסקה</a>
                    
                      
                    </div>
                    <div className="divider">|</div>
                    <div className="user-info">
                        <div className="user-email">{userData.email}</div>
                        <div className="user-actions">
                            <div className="icon user"></div>
                            <Notifications />
                            {/* <div className="icon notifications"></div> */}
                        </div>
                    </div>
                    <div className="divider">|</div>
                    <div className="logo-noah"></div>
                </div>
            </header>
        
      );
    
}

export default Header;
